// extracted by mini-css-extract-plugin
export var videoContainer = "_ji-0";
export var videoIframe = "_ji-3";
export var videoLink = "_ji-1";
export var videoOverlay = "_ji-4";
export var videoOverlayText = "_ji-5";
export var videoWrapper = "_ji-2";